let internalOptions = [
    'CQ: Add Custom Question'
];

export const add = (context, row, key, columns) => {

    if (row.length) {
        Object.keys(row).forEach(i => {
            if (!row[i]) return

            if (!context[columns].includes(row[i][key])) {
                context.$set(context[columns], context[columns].length, row[i][key])
            }

            if (row[i] !== undefined && internalOptions.includes(row[i][key])) {
                if ((context.customQuestionID = prompt('What is the Custom Question ID?'))) {
                    context.$set(context[columns], context[columns].length, `{{CQ: ${context.customQuestionID}}}`);
                }

                context.$set(row[i], key, context.customQuestionID ? `{{CQ: ${context.customQuestionID}}}` : '');
                context.$store.commit('exportDetails/SET_LEAD_TABLE_COLUMNS', context[columns].concat(`{{CQ: ${context.customQuestionID}}}`));
            }
        })
    }
}

export let options = internalOptions;